import { apiClient } from '@/lib/api-client';
import type {
  ActiveClientResponse,
  ClientesAcessiveisResponse,
} from '@just-frotas/shared';

// CORE multi-tenancy: lista clientes acessiveis e troca o cliente ativo
// da sessao. Resposta de switch traz novo accessToken (com clientId
// atualizado nas claims) que substitui o atual no storage.
export const activeClientService = {
  list(busca?: string): Promise<ClientesAcessiveisResponse> {
    const qs = busca ? `?busca=${encodeURIComponent(busca)}` : '';
    return apiClient.request<ClientesAcessiveisResponse>(`/auth/clientes-acessiveis${qs}`);
  },

  switch(clienteUuid: string): Promise<ActiveClientResponse> {
    return apiClient.request<ActiveClientResponse>('/auth/active-client', {
      method: 'POST',
      body: { clienteUuid },
    });
  },
};
